import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from '../TaskDetails.style';
import {TaskDetailsContent} from '../TaskDetailsContent';
interface CommonTaskDetailsProps {
  label: string;
}

export const CommonTaskDetails: React.FC<CommonTaskDetailsProps> = ({
  label,
}) => {
  const {ts} = useTranslation(`clientProfile.clientJourney.firstWeek.${label}`);

  return (
    <>
      <View style={styles.taskDetailContent}>
        <Text
          variant="button"
          style={styles.taskDetailContentText}
          {...testProperties(DownlineProfile.cjTaskDetailsBulletsHeaderText)}>
          {ts(
            'details',
            'The first few days may be an adjustment for your Client. So on this call, be sure to:',
          )}
        </Text>
      </View>
      <TaskDetailsContent
        taskDetailsList={[
          ts(
            'detailsListItem1',
            'Celebrate your Client’s commitment and continue to remind them of their why(s).',
          ),
          ts(
            'detailsListItem2',
            'Remind your Client to stay hydrated & eat every 2-3 hours and within 1 hour of waking up.',
          ),
          ts(
            'detailsListItem3',
            'Ask if they’ve had the chance to explore your Client Support Page.',
          ),
          ts('detailsListItem4', 'Schedule time the next day'),
          ts(
            'detailsListItem5',
            'You’ll find some additional tips for the first few days on the program in the Health Assessment.',
          ),
        ]}
        style={{
          base: styles.listItemContainer,
          listItem: styles.listItem,
        }}
      />
    </>
  );
};
